import type { ReactNode } from "react";
import { cn } from "../../lib/cn.js";

export function EmptyState({
  title,
  description,
  action,
  className,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-[var(--card-radius)] border border-dashed",
        "border-border-default bg-surface-overlay/50 px-6 py-10 text-center",
        className
      )}
    >
      <p className="text-sm font-medium text-content-primary">{title}</p>
      {description && <p className="text-sm text-content-secondary mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
